import { equals } from "ramda";

export const doValuesDifferFromDefaults = (defaults: object, values: object): boolean =>
  !equals({ ...defaults, ...values }, defaults);
